<template>
  <div
    :id="id"
    class="modal"
    tabindex="-1"
    role="dialog"
    aria-hidden="true"
    data-keyboard="false"
    data-backdrop="static"
  >
    <div
      class="modal-dialog "
      role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{ title }}</h5>
          <button
            type="button"
            class="close"
            aria-label="Close"
            @click="onClose">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <ModuleTransactionCount
            v-for="(app, index) in items"
            :key="index"
            :appId="app.app_id"
            :list="app.modules"
            color=""
          />
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-light"
            @click="onClose"
          >
            {{ $t('button.close') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-undef */

import { uuid } from 'vue-uuid'
import ModuleTransactionCount from '@/components/custom/ModuleTransactionCount'

export default {
  components: {
    ModuleTransactionCount,
  },

  props: ['show', 'items', 'title'],

  computed: {
    id () {
      return `${uuid.v1()}-app-module-list`
    },
  },

  watch: {
    show () {
      if (this.show) {
        $(`#${this.id}`).modal('show')

        document.getElementById(this.id).style.zIndex = 1051
        document.querySelectorAll('.modal-backdrop').forEach((ele) => {
          ele.style.zIndex = 1050
        })
      } else {
        $(`#${this.id}`).modal('hide')

        document.getElementById(this.id).style.zIndex = 1050
        document.querySelectorAll('.modal-backdrop').forEach((ele) => {
          ele.style.zIndex = 1040
        })
        const anyModalStillShown = [...document.querySelectorAll('.modal')].some((ele) => ele.style.display === 'block')
        if (anyModalStillShown) {
          window.document.body.classList.add('modal-open')
        }
      }
    },
  },

  mounted () {
    this.setModal(`#${this.id}`)
    if (this.show) {
      $(`#${this.id}`).modal('show')
    }
  },

  destroyed () {
    $(`#${this.id}`).remove()
  },

  methods: {
    onClose () {
      this.$emit('onClose')
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/base/BaseAppModuleListModule.vue